import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  caseActionSubmitFail,
  caseActionSubmitSuccess,
  CASE_ACTION_SUBMIT
} from '../../redux/actions/cm/caseAction';

import { caseActionSubmit } from '../../services/cm/cases';
import { fetchHistoryForCase } from '../../services/cm/historyItems';

function* caseActionSubmitWorker({ caseActionDetails }) {
  try {
    yield call(caseActionSubmit, { caseActionDetails });
    yield put(caseActionSubmitSuccess());
  } catch (error) {
    yield put(caseActionSubmitFail());
  }
}

export function* watchCaseActionSubmit() {
  yield takeEvery(
    CASE_ACTION_SUBMIT,
    function* ({ payload: { caseActionDetails } }) {
      yield fork(caseActionSubmitWorker, { caseActionDetails });
    }
  );
}
